// extracted by mini-css-extract-plugin
export var container = "_rw-0";
export var table = "_rw-2";
export var tableWrapper = "_rw-1";